import { AlertCircle } from 'lucide-react'

/** Aviso de erro no topo de um formulário. */
export function FormAlert({ message }: { message: string | null }) {
  if (!message) return null
  return (
    <div
      className="flex items-start gap-2 rounded-lg border border-critical/30 bg-critical/8 px-3 py-2 text-sm text-critical"
      role="alert"
    >
      <AlertCircle className="mt-0.5 size-4 shrink-0" />
      <span>{message}</span>
    </div>
  )
}
